<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">{{ data.platform_name }} 售后服务</div>
<div class="content" [formGroup]="formGroup">
  <div class="subtitle">
    您好，请在下方填写更详细的原因，以便我们更快理解并处理您的问题。我们将在
    24小时 内解决您的问题。请填写：
  </div>
  <div class="detail">
    <textarea formControlName="detail"></textarea>
    <app-image-uploader-qiniu
      formControlName="icon"
      width="250px"
      height="100px"
      [ratio]="2.5"
    ></app-image-uploader-qiniu>
  </div>
  <div class="button">
    <button [disabled]="formGroup.invalid || loading" (click)="reply()">
      确定
    </button>
  </div>
</div>
